import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

@Component({
    selector: 'app-simple-list',
    templateUrl: './simple-list.component.html',
    styleUrls: ['./simple-list.component.scss'],
})
export class SimpleListModalComponent implements OnInit {

    public Title: string = "";
    public Data: any[] = [];

    /** Texto de enquadramento da lista (opcional). */
    public Description: string = "";

    /** Texto apresentado quando a lista não tem nenhum item (opcional). */
    public EmptyDescription: string = "";

    /** Listas muito grandes: número de chips por bloco e quantos estão visíveis. */
    public readonly PageSize: number = 150;
    public Limit: number = this.PageSize;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController) {

        this.Title = this.NavParams.get('title');
        this.Data = this.NavParams.get('data');
        this.Description = this.NavParams.get('description') || "";
        this.Filtered = [...(this.Data || [])];
        this.EmptyDescription = this.NavParams.get('emptyDescription') || "";


        console.log(this.Data);

    }


    ngOnInit() { }

    /** Texto da pesquisa e itens filtrados. */
    public SearchText: string = "";
    public Filtered: any[] = [];

    /** A lista (sem filtro) tem itens. */
    get HasItems(): boolean {
        return (this.Data?.length || 0) > 0;
    }

    public TrackByIndex(index: number): number {
        return index;
    }

    /** Nova pesquisa (por nome, sem distinguir maiúsculas): filtra e volta ao primeiro bloco. */
    public OnSearch(ev?: any) {

        this.SearchText = (ev?.detail?.value ?? ev?.target?.value ?? "").toString().trim().toLowerCase();

        this.Filtered = this.SearchText
            ? (this.Data || []).filter(it => (it?.Name || "").toString().toLowerCase().includes(this.SearchText))
            : [...(this.Data || [])];

        this.Limit = this.PageSize;
    }

    /** Chegou ao fim do scroll: mostra mais um bloco. */
    public OnLoadMore(ev: any) {
        this.Limit += this.PageSize;
        ev?.target?.complete();
    }

    Close() {

        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }

}
